import { Check, Error, HourglassBottom } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import React from 'react';
import { FormattedMessage } from 'react-intl';

function VirusScanStatusIcon({ status }: any) {
  switch (status) {
    case 'clean':
      return (
        <Box sx={{ display: 'inline-flex' }}>
          <Check color="success" fontSize="small" />
          <Typography variant="body2" sx={{ color: 'success.dark' }}>
            <FormattedMessage id="VIRUS_SCAN.CLEAN" />
          </Typography>
        </Box>
      );
    case 'infected':
      return (
        <Box sx={{ display: 'inline-flex' }}>
          <Error color="error" fontSize="small" />
          <Typography variant="body2" color="error">
            <FormattedMessage id="VIRUS_SCAN.INFECTED" />
          </Typography>
        </Box>
      );
    default:
      return (
        <Box sx={{ display: 'inline-flex' }}>
          <HourglassBottom color="action" fontSize="small" />
          <Typography variant="body2" color="action">
            <FormattedMessage id="VIRUS_SCAN.NO_SCAN" />
          </Typography>
        </Box>
      );
  }
}

export default VirusScanStatusIcon;
